/**
 * CONNECT.1 (gate D2). Premium partners are for members 18 and older.
 *
 * Kollegio's form asks for a birth month and year, and nothing ever read them.
 * Age in whole years from those two fields, or null when there is no usable
 * birth date yet (the form's own required rule covers an empty one).
 *
 * Month and year only, so the birthday month counts as reached: somebody born
 * in September 2008 is 18 for all of September 2026, erring by at most a month
 * in the member's favour. The subgraph applies the same rule
 * (premium-partner-validation.ts, premiumPartnerAge), which is the boundary;
 * this is the one that tells the member before they press anything.
 */
export function premiumPartnerAge(
  data: unknown,
  referenceDate: Date = new Date()
): number | null {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return null;
  }
  const record = data as Record<string, unknown>;
  const year = Number(String(record['birthYear'] ?? '').trim());
  const month = Number(String(record['birthMonth'] ?? '').trim());
  if (!Number.isInteger(year) || year < 1900) {
    return null;
  }
  if (!Number.isInteger(month) || month < 1 || month > 12) {
    return null;
  }

  const nowMonth = referenceDate.getMonth() + 1;
  return referenceDate.getFullYear() - year - (nowMonth < month ? 1 : 0);
}

/** The same words the subgraph refuses with, so the two never disagree. */
export const PREMIUM_PARTNER_UNDER_18_MESSAGE =
  'This partner is only available to members 18 and older, so we will not send them your details.';
